// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"2863":"css/inline-layout/inline-layout","3107":"css/print","6938":"css/style","7628":"css/libs","8157":"css/inline-layout/inline-layout-libs","9754":"css/editmode"}[chunkId] + ".css";
};